import { getLocale } from "../runtime";

const sv_campaignexpired = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `För sent! Kampanjen är slut.`
};

const campaignexpired = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_campaignexpired(inputs)
	return "campaignExpired";
};

export { campaignexpired as "campaignExpired" };